module.exports = __webpack_public_path__ + "static/img/error_message.bcb5aea.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/nals/error_message.gif
// module id = PWqq
// module chunks = 0